import ArticleCommentModel from './ArticleCommentModel';

export default class ArticleModel {
  constructor(data) {
    if (!data) {
      data = {};
    }

    this.id = data.id || 0;
    this.topic = data.topic || '';
    this.description = data.description || '';
    this.num_comments = data.num_comments || 0;
    
    this.created = new Date(data.created);
    this.ordered_comments = (data.ordered_comments || []).map(c => new ArticleCommentModel(c));
  }
}
